import * as React from 'react';
import { NumberField as BaseNumberField } from '@base-ui-components/react/number-field';
import OutlinedInput from '@mui/material/OutlinedInput';

const NumberFieldBaseUI = React.forwardRef((ctrlprops, ref) => {
  const { placeholder, error = null, ...rest } = ctrlprops;
  return (
    <BaseNumberField.Root {...rest}>
      <BaseNumberField.Input
        render={(props, state) => {
          return (
            <OutlinedInput
              size="small"
              sx={{ mt: '-5px' }}
              fullWidth
              slotProps={{
                input: props,
              }}
              value={state.inputValue}
              inputRef={ref}
              onBlur={props.onBlur}
              onChange={props.onChange}
              onKeyUp={props.onKeyUp}
              onKeyDown={props.onKeyDown}
              onFocus={props.onFocus}
              placeholder={placeholder}
              error={Boolean(error)}
            />
          );
        }}
      />
    </BaseNumberField.Root>
  );
});

export default NumberFieldBaseUI;
